export const molecularScaffold = [
    {
        label: "blocks_file",
        alias: "Fragment building blocks",
        type: "file",
        required: true,
        disabled : false,
        helperText: "Fragment set to be used for molecular generation. You can choose from the options or upload a custom fragment file.",
        span:   6,          // ← column width (AntD grid 24‑based)
        mb:     12,         // ← margin‑bottom (px)
        labelSize: 13,      // ← font‑size (px)
        labelWeight: 500, // ← font‑weight   
    },
];

export const molecularScaffoldAdvance = [
    {
        label: "capping",
        alias: "Enable Capping",
        type: "toggle",
         span: 4,
        defaultValue: false,
        helperText: "Enable or disable capping for the scaffold.",
         helperUrl: "https://example.com/docs/some-field",
    }
];

export const learningRelated = [
    // {
    //     label: "mbsize",
    //     alias: "Minibatch Size",
    //     type: "number",
    //     step: "1",
    //     required: true,
    //     defaultValue: 4,
    //     helperText: "Specify the size of the minibatch.",
    //       helperUrl: "https://example.com/docs/some-field",
    // },
    // {
    //     label: "nemb",
    //     alias: "Embedding dimension",
    //     type: "number",
    //     step:"1",
    //     required: true,
    //     defaultValue: 256,
    //     helperText: "Embedding dimension for the GNN model.",
    //       helperUrl: "https://example.com/docs/some-field",
    // },
    {
        label: "min_blocks",
        alias: "Minimum fragments",
        type: "select",
        required: true,
            span  : 4,      // ↔ wider column
            disabled : false,
        defaultValue: 2,
        options: [1,2,3,4,5,6,7],
        helperText: "Set the minimum number of fragments to be attached to the scaffold.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "max_blocks",
        alias: "Maximum fragments",
        type: "select",
        required: true,
        defaultValue: 5,
        options: [2,3,4,5,6,7,8],
        helperText: "Set the maximum number of fragments to be attached to the scaffold.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "num_iterations",
        alias: "Iterations",
        type: "number",
        span: 8,
        step: "1",
        required: true,
        defaultValue: 1000,
        maxvalue: 30000,
        helperText: "Number of iterations for generation.",
          helperUrl: "https://example.com/docs/some-field",
    }
];

export const learningRelatedAdvance = [
    {
        label: "mbsize",
        alias: "Minibatch Size",
        type: "number",
        step: "1",
        required: true,
        defaultValue: 4,
        helperText: "Specify the size of the minibatch.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "nemb",
        alias: "Embedding dimension",
        type: "number",
        step:"1",
        required: true,
        defaultValue: 256,
         disabled : false,
        helperText: "Embedding dimension for the GNN model.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "device",
        alias: "Device",
        type: "select",
        required: true,
        defaultValue: "cuda",
        options: ["cpu", "cuda"],
        helperText: "Cuda is fast and expensive than cpu.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "learning_rate",
        alias: "Learning Rate",
        type: "text",
        defaultValue: "5e-4",
        helperText: "Set the learning rate for the model.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "opt_beta",
        alias: "Optimizer Beta",
        type: "number",
        step: "0.1",
        defaultValue: 0.9,
        helperText: "Set the beta value for the optimizer.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "opt_beta2",
        alias: "Optimizer Beta2",
        type: "number",
        step: "0.001",
        defaultValue: 0.999,
        helperText: "Set the beta2 value for the optimizer.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "opt_epsilon",
        alias: "Optimizer Epsilon",
        type: "text",
        defaultValue: "1e-8",
        helperText: "Set the epsilon value for the optimizer.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "num_conv_steps",
        alias: "Num. of convolution layers",
        type: "number",
        step: "1",
        defaultValue: 10,
         disabled : false,
        helperText: "Number of convolution layers for the network.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "log_reg_c",
        alias: "Regularization constant",
        type: "text",
        defaultValue: "2.5e-5",
        helperText: "Regularization constant.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "reward_exp",
        alias: "Reward Exponent",
        type: "number",
        step: "0.1",
        defaultValue: 1,
        helperText: "Exponent for reward calculation.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "reward_norm",
        alias: "Reward Normalization",
        type: "number",
        defaultValue: 1,
        helperText: "Normalization constant for rewards.",
          helperUrl: "https://example.com/docs/some-field",
    },
    {
        label: "sample_prob",
        alias: "Sample Probability",
        type: "number",
        step: "0.1",
        defaultValue: 1,
        helperText: "Probability of sampling molecules.",
    },
    {
        label: "R_min",
        alias: "Minimum Reward",
        type: "number",
        step: "0.1",
        defaultValue: 0.1,
        helperText: "Rewards below this value are clipped to this value."
    },
    {
        label: "leaf_coef",
        alias: "Leaf Coefficient",
        type: "number",
        step: "0.1",
        defaultValue: 10,
        helperText: "Weight of the leaf nodes on loss.",
    },
    {
        label: "clip_grad",
        alias: "Clip Gradient",
        type: "number",
        step: "0.1",
        defaultValue: 0,
        helperText: "Gradient clipping.",
    },
    {
        label: "clip_loss",
        alias: "Clip Loss",
        type: "number",
        step: "0.1",
        defaultValue: 0,
        helperText: "Loss for gradient clipping",
    },
    {
        label: "replay_mode",
        alias: "Replay Mode",
        type: "select",
        defaultValue: "online",
        options: ["online"],
        helperText: "Mode for replay for RL.",
    },
    {
        label: "bootstrap_tau",
        alias: "Bootstrap Tau",
        type: "number",
        step: "0.1",
        defaultValue: 0,
        helperText: "Tau value for bootstrapping.",
    },
    {
        label: "weight_decay",
        alias: "Optimized weight decay",
        type: "number",
        step: "0.1",
        defaultValue: 0,
        helperText: "Optimized weight decay.",
    },
    {
        label: "random_action_prob",
        alias: "Random Action Probability",
        type: "number",
        step: "0.01",
        defaultValue: 0.05,
        helperText: "Set the probability of sampling random actions."
    },
    // {
    //     label: "repr_type",
    //     alias: "Fragment representation type",
    //     type: "select",
    //     defaultValue: "block_graph",
    //     options:["block_graph"],
    //     helperText: "Specify the type of representation for fragments.",
    // },
    {
        label: "model_version",
        alias: "Model Version",
        type: "select",
        defaultValue: "v4",
         disabled : false,
        options: ["v4"],
        helperText: "Specify the version of the model.",
    },
    // {
    //     label: "run",
    //     alias: "Run Number",
    //     type: "number",
    //     step: "1",
    //     defaultValue: 0,
    //     helperText: "Specify the run number.",
    // },
    // {
    //     label: "floatX",
    //     alias:"Floating point precision",
    //     type: "select",
    //     defaultValue: "float64",
    //     options: [ "float64", "float32"],
    //     helperText: "Choose between float32 and float64.",
    // },
    // {
    //     label: "include_nblocks",
    //     type: "toggle",
    //     defaultValue: "False",
    //     helperText: "",
    // },
    // {
    //     label: "balanced_loss",
    //     type: "toggle",
    //     defaultValue: "True",
    //     helperText: "",
    // },
    // {
    //     label: "do_wrong_thing",
    //     type: "toggle",
    //     defaultValue: "False",
    //     helperText: "",
    // },
    // {
    //     label: "batchwise_reward",
    //     type: "toggle",
    //     defaultValue: "False",
    //     helperText: "",
    // },
    {
        label: "reward_mode",
        alias: "Reward transformation",
        type: "select",
        defaultValue: "exp_scaling",
        options: ["exp_scaling", "random"],
         disabled : false,
        helperText: "Transformation to be applied on reward term.",
    },
    // {
    //     label: "sample_unique_only",
    //     alias: "Pretrained Parameter File",
    //     type: "text",
    //     defaultValue: "",
    //     helperText: "Enable or disable 'do wrong thing' option.",
    // },
    {
        label: "unique_samples",
        alias: "Unique molecules",
        type: "toggle",
         span: 4,
        defaultValue: true,
        helperText: "Enable only sampling unique molecules.",
    },
    // {
    //     label: "multithreading",
    //     type: "text",
    //     defaultValue: "",
    //     helperText: "",
    // },
    // {
    //     label: "no_multithreading",
    //     type: "text",
    //     defaultValue: "",
    //     helperText: "",
    // },
    // {
    //     label: "system",
    //     type: "text",
    //     defaultValue: "brainiac",
    //     helperText: "",
    // },
    {
        label: "assign_partial_rewards",
        alias: "Partial rewards",
        type: "toggle",
        defaultValue: false,
        helperText: "Enable or disable assignment of partial rewards for different passing filters.",
    },
];

export const checkpointingAdvance = [
    {
        label: "save_path",
        alias: "Save Path",
        type: "text",
        defaultValue: "./results/",
        helperText: "Path to save results."
    },
    // {
    //     label: "proxy_path",
    //     type: "text",
    //     defaultValue: "./data/pretrained_proxy",
    //     helperText: ""
    // },
    // {
    //     label: "pretrained_param_file",
    //     type: "text",
    //     defaultValue: "",
    //     helperText: ""
    // },
    // {
    //     label: "temp_dir",
    //     type: "text",
    //     defaultValue: "./data/",
    //     helperText: ""
    // }
];

//export const loggingAdvance = [
    // {
    //     label: "print_array_length",
    //     type: "toggle",
    //     defaultValue: "False",
    //     helperText: ""
    // },
    // {
    //     label: "progress",
    //     type: "text",
    //     defaultValue: "Yes",
    //     helperText: ""
    // },
    // {
    //     label: "verbose",
    //     type: "toggle",
    //     defaultValue: "False",
    //     helperText: ""
    // }
//];

export const constraints3 = [
    {
        label: "include_similarity_to_ref",
        alias: "Reward similar compounds to reference",
        type: "toggle",
        required: true,
         span: 6,  
        defaultValue: false,
        helperText: "Enable or disable inclusion of similarity scores to reference compounds."
    },
    // {
    //     label: "ref_compounds",
    //     alias: "Reference compounds",
    //     type: "select",
    //     required: true,
    //     options: ["Choose File"],
    //     helperText: "Reference compound set."
    // },
  {
    label: "ref_compounds",
    alias: "Reference compounds",
    type: "file",
     span: 5,   
    required: true,
    helperText: "Reference compound set.",
  },
];

export const constraints4 = [
    // {
    //     label: "include_ringrarity",
    //     alias: "Ring rarity filter",
    //     type: "toggle",
    //     required: false,
    //     span  : 6,      // ↔ wider column
    //     disabled : false,
    //     defaultValue: false,
    //     helperText: "Enable or disable inclusion of ring rarity filter. This penalizes molecules with containing rare ring systems."
    // },
    // {
    //     label: "microsomal_limit",
    //     alias: "Human Microsomal Clearance Limit (<=)",
    //     type: "number",
    //     step: "0.1",
    //     required: true,
    //     defaultValue: 1000,
    //     helperText: "Upperlimit on the predicted Human Microsomal Clearance."
    // },
    // {
    //     label: "microsomal_model_type",
    //     alias: "Human Microsomal Clearance Model",
    //     type: "select",
    //     required: true,
    //     options: ["sprime","nexora"],
    //     defaultValue: "sprime",
    //     helperText: "Choose model for predicting clearance of generated molecules."
    // },
    // {
    //     label: "mdck_limit",
    //     alias: "Permeability (>)",
    //     type: "number",
    //     step: "0.01",
    //     required: true,
    //     defaultValue: -0.31,
    //     helperText: "Lowerlimit on the predicted permeability."
    // },
    // {
    //     label: "mdck_model_type",
    //     alias: "Permeability Model",
    //     type: "select",
    //     required: true,
    //     options: ["sprime","nexora"],
    //     defaultValue: "sprime",
    //     helperText: "Choose model for predicting clearance of generated molecules."
    // },
    // {
    //     label: "w_filters_file",
    //     alias: "w_filters_file",
    //     type: "text",
    //     required: true,
    //     defaultValue: "",
    //     helperText: ""
    // }
];

export const constraints7 = [
    {
        label: "include_clogD",
        alias: "clogD filter",
         span: 4,
         disabled: true,
        type: "toggle",
        required: false,
        defaultValue: false,
        helperText: "Enable or disable inclusion of clogD filter in reward."
    },
    {
        label: "clogD_limit",
        alias: "clogD_limit",
        type: "slider",
        step: "0.1",
        required: true,
        defaultValue: [0.0,5.0],
        helperText: ""
    },
    {
        label: "clogD_l_limit",
        alias: "clogD Lower Limit",
        type: "number",
        step: "0.1",
        minvalue: -20,
          span: 4,
        maxvalue: 50,
        required: true,
        defaultValue: 0.0,
        helperText: ""
    },
    {
        label: "clogD_u_limit",
        alias: "clogD Upper Limit",
        type: "number",
          span: 4,
        step: "0.1",
        minvalue: -20,
        maxvalue: 50,
        required: true,
        defaultValue: 0.0,
        helperText: ""
    }
];

export const constraints8 = [
    {
        label: "include_pKa",
        alias: "pKa filter",
        type: "toggle",
        required: false,
        disabled: true,
           span: 4,
        defaultValue: false,
        helperText: "Enable or disable inclusion of pKa filter in reward."
    },
    {
        label: "pKa_limit",
        alias: "pKa_limit",
        type: "slider",
        step: "0.1",
        required: true,
        defaultValue: [5.0,8.0],
        helperText: ""
    },
    {
        label: "pKa_llimit",
        alias: "pKa Lower Limit",
        type: "number",
           span: 4,
        step: "0.1",
        minvalue: -20,
        maxvalue: 50,
        required: true,
        defaultValue: 5.0,
        helperText: ""
    },
    {
        label: "pKa_ulimit",
        alias: "pKa Upper Limit",
        type: "number",
        step: "0.1",
           span: 4,
        minvalue: -20,
        maxvalue: 50,
        required: true,
        defaultValue: 8.0,
        helperText: ""
    }
];

export const constraints5 = [
    {
        label: "include_potency",
        alias: "Potency filter",
        type: "toggle",
        required: false,
         span  : 6,      // ↔ wider column
        disabled : true,
        
        defaultValue: false,
        helperText: "Enable or disable inclusion of potency in reward."
    },
    {
        label: "potency_model_script",
        alias: "Potency Model",
        type: "select",
        required: true,
        defaultValue: "None",
        options: ["None"],
        helperText: "Specify potency model to be used."
    }
];

export const constraints6 = [
    {
        label: "docking_proxy_filter",
        alias: "Docking Proxy Filter",
        type: "toggle",
        required: false,
         disabled : true,
        defaultValue: false,
        helperText: "Enable or disable inclusion of medchem filters in the reward."
    },
    {
        label: "docking_model",
        alias: "Docking proxy model",
        type: "select",
        required: true,
        defaultValue: "None",
        options: ["None"],
        helperText: "Specify docking proxy model to be used."
    },
    {
        label: "docking_model_type",
        alias: "Docking Model Type",
        type: "select",
        required: true,
        defaultValue: "classifier",
        options: ["classifier", "regressor" ],
        helperText: "Specify whether the docking model is a classifier or regessor."
    },
    {
        label: "docking_reward_utility_function",
        alias: "Docking Reward Utility Function",
        type: "select",
        required: true,
        defaultValue: "sigmoid",
        options: ["sigmoid"],
        helperText: "Specify parameters for sigmoid utility function."
    },
    {
        label: "docking_reward_sigmoid_params",
        alias: "Docking Reward Sigmoid Parameters",
        type: "text",
        step: "0.1",
        required: true,
        defaultValue: "[1,0,0,-1]",
        helperText: "Parameters for the sigmoid utility function. Default values are a=1, b =0, c=0, d=-1. d/(1+exp(-a*(x-b))) + c"
    }
];

export const constraints9 = [ 
    {
        label: "include_medchemrules",
        alias: "MedChem filters",
        type: "toggle",
           span: 4,
        disabled: true,
        required: false,
        defaultValue: false,
        helperText: "Enable or disable inclusion of medchem filters in the reward."
    },
    {
        label: "medchemrules_thres",
        alias: "Demerits threshold",
        type: "number",
        step: "0.1",
           span: 4,
        disabled: true,
        required: true,
        defaultValue: 300,
        helperText: "Threshold for demerits to filter based on medchem rule violations."
    },
];

export const constraints1 = [
    {
        label: "microsomal_limit",
        alias: "Human Microsomal Clearance Limit (<=)",
        type: "number",
        step: "0.1",
         span  : 6,      // ↔ wider column
//   disabled : false,
   mb:   16,
        required: true,
        defaultValue: 1000,
        helperText: "Upperlimit on the predicted Human Microsomal Clearance."
    },
    {
        label: "microsomal_model_type",
        alias: "Human Microsomal Clearance Model",
        type: "select",
          span  : 6, 
           mb:   16,  
        required: true,
        options: ["sprime","nexora"],
        defaultValue: "sprime",
        helperText: "Choose model for predicting clearance of generated molecules."
    },
]
export const constraints2 = [
        {
        label: "mdck_limit",
        alias: "Permeability (>)",
        type: "number",
        step: "0.01",
        required: true,
          span  : 4,  
           mb:   16,  
        defaultValue: -0.31,
        helperText: "Lowerlimit on the predicted permeability."
    },
    {
        label: "mdck_model_type",
        alias: "Permeability Model",
        type: "select",
        required: true,
         mb:   16,  
        options: ["sprime","nexora"],
        defaultValue: "sprime",
        helperText: "Choose model for predicting clearance of generated molecules."
    },
]

export const w_filters_1 = [
    {
        label: "mW",
        alias: "mW",
        type: "slider",
        step: "1",
        required: true,
           span: 6,

        defaultValue: [300,1000],
        helperText: ""
    },
    {
        label: "w_amw_0",
        alias: "Min. mW",
        type: "number",
        step: "1",
           span: 4,

        minvalue: 0,
        maxvalue: 1000,
        required: true,
        defaultValue: 300,
        helperText: ""
    },
    {
        label: "w_amw_1",
        alias: "Max. mW",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 1000,
           span: 4,

        required: true,
        defaultValue: 1000,
        helperText: ""
    }
];

export const w_filters_2 = [
    {
        label: "limit_chiral_centers",
        alias: "Limit chiral centers",
        type: "toggle",
         span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "chiral_centers",
        alias: "Chiral centers",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [0,2],
        helperText: ""
    },
    {
        label: "w_nchiral_0",
        alias: "Min. chiral centers",
        type: "number",
        step: "1",
        minvalue: 0,
           span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 0,
        helperText: ""
    },
    {
        label: "w_nchiral_1",
        alias: "Max. chiral centers",
        type: "number",
          span: 4,
        step: "1",
        minvalue: 0,
        maxvalue: 10,
        required: true,
        defaultValue: 2,
        helperText: ""
    }
];

export const w_filters_3 = [
    {
        label: "limit_ring_size",
        alias: "Limit ring size",
        type: "toggle",
          span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "ring_size",
        alias: "Ring Size",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [3,7],
        helperText: ""
    },
    {
        label: "w_lrsz_0",
        alias: "Smallest ring size",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 10,
          span: 4,
        required: true,
        defaultValue: 3,
        helperText: ""
    },
    {
        label: "w_lrsz_1",
        alias: "Largest ring size",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 10,
        required: true,
          span: 4,
        defaultValue: 7,
        helperText: ""
    }
];

export const w_filters_4 = [
    {
        label: "limit_number_of_rings",
        alias: "Limit number of rings",
        type: "toggle",
          span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "number_of_rings",
        alias: "Number of rings",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [4,10],
        helperText: ""
    },
    {
        label: "w_nrings_0",
        alias: "Min. rings",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 4,
        helperText: ""
    },
    {
        label: "w_nrings_1",
        alias: "Max. rings",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 10,
        helperText: ""
    }
];

export const w_filters_5 = [
    {
        label: "limit_number_of_aromatic_rings",
        alias: "Limit number of aromatic rings",
        type: "toggle",
          span: 5,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "number_of_aromatic_rings",
        alias: "Number of aromatic rings",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [1,5],
        helperText: ""
    },
    {
        label: "w_arrings_0",
        alias: "Min. aromatic rings",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 1,
        helperText: ""
    },
    {
        label: "w_arrings_1",
        alias: "Max. aromatic rings",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 10,
          span: 4,
        required: true,
        defaultValue: 5,
        helperText: ""
    }
];


export const w_filters_6 = [
    {
        label: "limit_rotatable_bonds",
        alias: "Limit rotatable bonds",
        type: "toggle",
          span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "rotatable_bonds",
        alias: "Rotatable bonds",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [1,10],
        helperText: ""
    },
    {
        label: "w_rotbond_0",
        alias: "Min. rotatable bonds",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 1,
        helperText: ""
    },
    {
        label: "w_rotbond_1",
        alias: "Max. rotatable bonds",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 10,
        helperText: ""
    }
];

export const w_filters_7 = [
    {
        label: "limit_halogens",
        alias: "Limit halogens",
        type: "toggle",
          span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "halogens",
        alias: "Halogens",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [0,3],
        helperText: ""
    },
    {
        label: "w_halogen_0",
        alias: "Min. halogens",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 0,
        helperText: ""
    },
    {
        label: "w_halogen_1",
        alias: "Max. halogens",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 10,
          span: 4,
        required: true,
        defaultValue: 3,
        helperText: ""
    }
];

export const w_filters_8 = [
    {
        label: "Limit_OH_NH",
        alias: "Limit OH, NH (RO5)",
        type: "toggle",
        required: true,
          span: 4,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "OH_NH",
        alias: "OH, NH (RO5)",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [1,5],
        helperText: ""
    },
    {
        label: "w_ro5_ohnh_0",
        alias: "Min. # of OH, NH",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 1,
        helperText: ""
    },
    {
        label: "w_ro5_ohnh_1",
        alias: "Max. # of OH, NH",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 5,
        helperText: ""
    }
];

export const w_filters_9 = [
    {
        label: "limit_polar_surface_area",
        alias: "Limit polar surface area",
        type: "toggle",
        required: true,
          span: 4,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "polar_surface_area",
        alias: "Polar surface area",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [0,150],
        helperText: ""
    },
    {
        label: "w_nvrtspsa_0",
        alias: "Min. PSA",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 150,
          span: 4,
        required: true,
        defaultValue: 0,
        helperText: ""
    },
    {
        label: "w_nvrtspsa_1",
        alias: "Min. PSA",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 150,
        required: true,
        defaultValue: 150,
        helperText: ""
    }
];

export const w_filters_10 = [
    {
        label: "limit_H_bond_donors",
        alias: "Limit H bond donors",
        type: "toggle",
        required: true,
          span: 4,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "H_bond_donors",
        alias: "H bond donors",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [0,5],
        helperText: ""
    },
    {
        label: "w_hdons_0",
        alias: "Min. H-bond donors",
        type: "number",
        step: "1",
        minvalue: 0,
          span: 4,
        maxvalue: 10,
        required: true,
        defaultValue: 0,
        helperText: ""
    },
    {
        label: "w_hdons_1",
        alias: "Max. H-bond donors",
        type: "number",
        step: "1",
          span: 4,
        minvalue: 0,
        maxvalue: 10,
        required: true,
        defaultValue: 5,
        helperText: ""
    }
];

export const w_filters_11 = [
    {
        label: "limit_H_bond_acceptors",
        alias: "Limit H bond acceptors",
        type: "toggle",
          span: 4,
        required: true,
        defaultValue: false,
        helperText: ""
    },
    {
        label: "H_bond_acceptors",
        alias: "H bond acceptors",
        type: "slider",
        step: "1",
        required: true,
        defaultValue: [0,7],
        helperText: ""
    },
    {
        label: "w_hacts_0",
        alias: "Min. H-bond acceptors",
        type: "number",
        step: "1",
        minvalue: 0,
        maxvalue: 10,
        required: true,
          span: 4,

        defaultValue: 0,
        helperText: ""
    },
    {
        label: "w_hacts_1",
        alias: "Max. H-bond acceptors",
        type: "number",
        step: "1",
          span: 4,

        minvalue: 0,
        maxvalue: 10,
        required: true,
        defaultValue: 7,
        helperText: ""
    }
];

export const contraintsAdvance = [
     {
        label: "include_tsubmatching",
        alias: "Penalize Substructures",
        type: "toggle",
        required: true,
         span: 6,  
        defaultValue: false,
        helperText: "Enable or disable inclusion of include_tsubmatching"
    },
    {
        label: "SMARTS_file",
        alias: "SMARTS to penalize",
        span: 4,
        type: "file",
        required: false,
        helperText: "Set of SMARTS query for bad substructures."
    },
];

// export const debuggingAdvance = [
//     {
//         label: "debug_proxy",
//         type: "toggle",
//         defaultValue: "False",
//         helperText: ""
//     },
// ];

export const dependantFields = [
    "include_similarity_to_ref", "include_clogD", "include_pKa", "include_potency", "include_medchemrules", "docking_proxy_filter",
    "limit_chiral_centers", "limit_ring_size", "limit_number_of_rings", "limit_number_of_aromatic_rings", "limit_mW",
    "limit_rotatable_bonds", "limit_halogens", "Limit_OH_NH", "limit_polar_surface_area", "limit_H_bond_donors", "limit_H_bond_acceptors", "capping",
];

export const dependantFieldDetails = [
    {
        name: "include_similarity_to_ref",
        fields: [{ key: "ref_compounds", default: "" }]
    },
    {
        name: "include_clogD",
        fields: [{ key: "clogD_l_limit", default: 0 }, { key: "clogD_u_limit", default: 5 }]
    },
    {
        name: "include_pKa",
        fields: [{ key: "pKa_llimit", default: 5 }, { key: "pKa_ulimit", default: 8 }]
    },
    {
        name: "include_potency",
        fields: [{ key: "potency_model_script", default: "" }]
    },
    {
        name: "include_medchemrules",
        fields: [{ key: "medchemrules_thres", default: 300 }]
    },
    {
        name: "docking_proxy_filter",
        fields: [{ key: "docking_model", default: "None" },
        { key: "docking_model_type", default: "classifier" },
        { key: "docking_reward_utility_function", default: "sigmoid"}, 
        { key: "docking_reward_sigmoid_params", default: [1, 0, 0, -1] }]
    },
    {
        name: "limit_chiral_centers",
        fields: [{ key: "w_nchiral_0", default: 0 }, { key: "w_nchiral_1", default: 2 }]
    },
    {
        name: "limit_ring_size",
        fields: [{ key: "w_lrsz_0", default: 3 }, { key: "w_lrsz_1", default: 7 }]
    },
    {
        name: "limit_number_of_rings",
        fields: [{ key: "w_nrings_0", default: 4 }, { key: "w_nrings_1", default: 10 }]
    },
    {
        name: "limit_number_of_aromatic_rings",
        fields: [{ key: "w_arrings_0", default: 1 }, { key: "w_arrings_1", default: 5 }]
    },
    {
        name: "limit_mW",
        fields: [{ key: "w_amw_0", default: 300 }, { key: "w_amw_1", default: 1000 }]
    },
    {
        name: "limit_rotatable_bonds",
        fields: [{ key: "w_rotbond_0", default: 1 }, { key: "w_rotbond_1", default: 10 }]
    },
    {
        name: "limit_halogens",
        fields: [{ key: "w_halogen_0", default: 0 }, { key: "w_halogen_1", default: 3 }]
    },
    {
        name: "Limit_OH_NH",
        fields: [{ key: "w_ro5_ohnh_0", default: 1 }, { key: "w_ro5_ohnh_1", default: 5 }]
    },
    {
        name: "limit_polar_surface_area",
        fields: [{ key: "w_nvrtspsa_0", default: 0 }, { key: "w_nvrtspsa_1", default: 150 }]
    },
    {
        name: "limit_H_bond_donors",
        fields: [{ key: "w_hdons_0", default: 0 }, { key: "w_hdons_1", default: 5 }]
    },
    {
        name: "limit_H_bond_acceptors",
        fields: [{ key: "w_hacts_0", default: 0 }, { key: "w_hacts_1", default: 7 }]
    },
    {
        name: "capping",
        fields: [{ key: "capping_scaffold", default: "" }]
    },
];

export const sliderFields = [
    {
        name: "clogD_limit",
        fields: [{ l_limit: "clogD_l_limit", u_limit: "clogD_u_limit" }]
    },
    {
        name: "pKa_limit",
        fields: [{ l_limit: "pKa_llimit", u_limit: "pKa_ulimit" }]
    },
    {
        name: "chiral_centers",
        fields: [{ l_limit: "w_nchiral_0", u_limit: "w_nchiral_1" }]
    },
    {
        name: "ring_size",
        fields: [{ l_limit: "w_lrsz_0", u_limit: "w_lrsz_1" }]
    },
    {
        name: "number_of_rings",
        fields: [{ l_limit: "w_nrings_0", u_limit: "w_nrings_1" }]
    },
    {
        name: "number_of_aromatic_rings",
        fields: [{ l_limit: "w_arrings_0", u_limit: "w_arrings_1" }]
    },
    {
        name: "mW",
        fields: [{ l_limit: "w_amw_0", u_limit: "w_amw_1" }]
    },
    {
        name: "rotatable_bonds",
        fields: [{ l_limit: "w_rotbond_0", u_limit: "w_rotbond_1" }]
    },
    {
        name: "halogens",
        fields: [{ l_limit: "w_halogen_0", u_limit: "w_halogen_1" }]
    },
    {
        name: "OH_NH",
        fields: [{ l_limit: "w_ro5_ohnh_0", u_limit: "w_ro5_ohnh_1" }]
    },
    {
        name: "polar_surface_area",
        fields: [{ l_limit: "w_nvrtspsa_0", u_limit: "w_nvrtspsa_1" }]
    },
    {
        name: "H_bond_donors",
        fields: [{ l_limit: "w_hdons_0", u_limit: "w_hdons_1" }]
    },
    {
        name: "H_bond_acceptors",
        fields: [{ l_limit: "w_hacts_0", u_limit: "w_hacts_1" }]
    },
    ]
